import React, { useEffect, useState } from "react";

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="nav"
      style={
        scrolled
          ? { background: "rgba(10,10,12,0.92)" }
          : undefined
      }
    >
      <a href="#top" className="nav__brand" aria-label="Soundwisdom AI 首页">
        <span className="nav__mark" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path className="arc arc--3" d="M5 12 Q 8 5  12 5 Q 16 5  19 12" />
            <path className="arc arc--2" d="M7.5 12 Q 9.5 8  12 8 Q 14.5 8  16.5 12" />
            <path className="arc"        d="M10 12 Q 11 11  12 11 Q 13 11  14 12" />
            <line className="cut" x1="3" y1="16" x2="21" y2="16" />
          </svg>
        </span>
        <span className="nav__brand-text">
          <strong>慧声计算机科技</strong>
          <small>SOUNDWISDOM&nbsp;·&nbsp;AI</small>
        </span>
      </a>

      <nav className="nav__links" aria-label="主导航">
        <a className="nav__link" href="#products">
          产品
        </a>
        <a className="nav__link" href="#collab">
          合作
        </a>
        <a className="nav__link" href="#manifesto">
          理念
        </a>
        <a
          className="nav__cta"
          href="mailto:zhangyuntian@soundwisdomai.com"
        >
          商务合作 →
        </a>
      </nav>
    </header>
  );
}

export default Header;
